import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, SetCartStatus } from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";
import cloneDeep from "lodash/cloneDeep";

addToChainAfter(chain, SetCartStatus, props => {
    const state = props.getState();
    const CustomState = (state as any).customState;

    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart and we are trying to place the current cart as an order.");
    }

    const {
        accountNumber,
    } = CustomState;

    props.cartToUpdate = {
        ...cloneDeep(props.cartToUpdate),
        // Adapty Custom Code Start

        properties: {
            accountNumber,
        },
        // Adapty Custom Code ENd
    };
});
